import React from 'react';
import { api_host } from '../common/globals/constants';
import { addDays, format } from 'date-fns';
import { useQuery } from '@tanstack/react-query';

export function useDataHeatMap({
  objetivoId,
  globalStatePeriod,
  periodo,
  enabled = true,
  refreshTime = false,
}) {
  return useQuery({
    queryKey: ['heatmapData', objetivoId, globalStatePeriod, periodo],
    queryFn: async () => {
      let token = sessionStorage.getItem('key');
      let user_id = sessionStorage.getItem('user');
      const start = Date.now();
      const { startDate, endDate } = globalStatePeriod;
      const inicio = format(new Date(startDate), 'yyyy-MM-dd');
      const termino = format(addDays(new Date(endDate), 1), 'yyyy-MM-dd');
      const hash = '3276bd408a114308ab00c6133fe29fb2';
      const key = '07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2';
      let url = `${api_host}/reporte/online/indicadores/HeatmapData/?user=${user_id}&objetiveId=${objetivoId}&fechaInicio=${inicio}&fechaTermino=${termino}&hash=${hash}&token=${token}&key=${key}&start=${start}`;
      return await fetch(url)
        .then((response) => response.json())
        .then((myJson) => {
          if (Array.isArray(myJson.data_pasos)) {
            return myJson.data_pasos[0]?.data ?? [];
          } else {
            throw new Error(myJson);
          }
        });
    },
    enabled,
    gcTime: 0, // 24 hours
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: refreshTime || false,
  });
}
